import type {VersionInfo} from './app/utils.class';

export const compiledVersion: VersionInfo = {"buildNumber":"D. van der Steen B.V_acceptance_2026-11-05_15-0-19","buildId":"24953","environment":"dvds-acceptance","datetime":"2026-11-05T14:02:02.739Z","checkForUpdates":true}